<template>
    <v-menu v-model="isShowMenu" offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on }">
            <v-text-field 
                v-model="placeName" 
                readonly 
                clearable 
                outlined 
                label="圃場"
                dense 
                @click:clear="onClickClearPlace" 
                prepend-icon="mdi-home-city" 
                hint="クリックして圃場を選択出来ます。" 
                persistent-hint 
                append-icon="mdi-menu-down"
                v-on="on" />
        </template>
            <v-list>
                <template v-for="item in menuItems">
                    <v-list-group v-if="item.children != null" no-action :key="item.text">
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>{{item.text}}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <v-list-item v-for="child in item.children" :key="child.id" @click="onSelectedItem(child)">
                            <v-list-item-content>{{child.text}}</v-list-item-content>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item v-if="item.children == null" :key="item.text" @click="onSelectedItem(item)">
                        <v-list-item-content>{{item.text}}</v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
    </v-menu>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,
                default: null
            },
            places: {
                type: Array,
                default: []
            },
            placeGroups: {
                type: Array,
                default: []
            }
        },
        data: function () {
            return {
                isShowMenu: false,
                // isShowSelector: false,
                placeName: "",
                selectedMenuItem: null,
                menuItems: []
            }
        },
        computed: {
            // selectorStyle: function () {
            //     var p = this.$refs.parent.getBoundingClientRect()
            //     console.log("position:absolute; top:" + (p.top - 30) + "px; left:" + p.left)
            //     return "position:absolute; top:" + (p.top - 30) + "px; left:" + p.left + "px"
            // },
            place: {
                get: function() {return this.$props.value},
                set: function(v) {
                    this.$emit("input", v)
                }
            }
        },
        created: function () {
            const self = this
            for(var i=0; i<this.placeGroups.length; i++) {                
                const groupItem = {
                    text: this.placeGroups[i].name,
                    value: this.placeGroups[i].placeGroupID,
                    group: this.placeGroups[i],
                    children: []
                }
                self.menuItems.push(groupItem)
                self.places.forEach(function(place){
                    if (place.placeGroupID != null && place.placeGroupID == self.placeGroups[i].placeGroupID) {
                        const item = {
                            text: place.name,
                            value: place.placeID,
                            place: place,
                        }
                        groupItem.children.push(item)
                    }
                })
            }
            this.places.forEach(function(place){
                if (place.placeGroupID == null || place.placeGroupID == '') {
                    const item = {
                        text: place.name,
                        value: place.placeID,
                        place: place,
                    }
                    self.menuItems.push(item)
                }
            })
            this.placeName = ""
        },
        methods: {
            onClickClearPlace: function () {
                console.log("onClickClearPlace")
                this.place = null
                this.placeName = ""
                this.selectedMenuItem = null
            },
            onSelectedItem: function (item) {
                console.log("onSelectedItem", item)
                this.isShowMenu = false
                this.place = item.value
                this.placeName = item.text
                this.selectedMenuItem = item
                this.isShowSelector = false
            }
        }
    }
</script>
